<div class="store-level store" *ngIf="globals.storeSettings"
    [ngClass]="{'ace-store': globals.storeSettings && globals.storeSettings.type == 'ace', 'partner-store': globals.storeSettings && globals.storeSettings.type == 'partner', 'new-font':globals.currentUser, 'partner-themed':globals.currentUser, 'container-background':globals.currentUser, 'shopify-user-theme': globals.useShopifyTheme()}">

    <div class="container">
        <div class="header" [ngClass]="{'container-background':globals.currentUser}">
            <div class="row" *ngIf="!globals.currentUser">
                <div class="col">
                    <h1 *ngIf="globals.storeSettings" class="capitalize">{{globals.storeSettings.name}}</h1>
                </div>
                <div class="col align-right right-side">
                    <h5 class="clickable" [routerLink]="[globals.panelUrl('/credit-transactions')]"
                        *ngIf="globals.storeSettings && globals.storeSettings.type == 'partner'">Krediter:
                        {{utility.numberFormat(globals.storeSettings.credits)}}</h5>
                </div>
            </div>


            <div class="row" *ngIf="globals.currentUser">
                <div class="col">
                    <img src="/gateway-app/browser/assets/ace-logo-white.png" class="logo" />
                    <div *ngIf="globals.storeSettings.type == 'partner' && globals.storeSettings.onboardingPending">
                        <button mat-stroked-button class="getting-started-btn" (click)="forceOpenOnboardingDialog()">
                            <span class="material-symbols-outlined">rocket_launch</span>
                            {{ 'Getting started' | translate }}
                        </button>
                    </div>
                </div>
                <div class="col align-right print-hide">
                    <div>
                        <h4>{{globals.storeSettings.name}}</h4>
                        <h6 class="clickable" [routerLink]="[globals.panelUrl('/credit-transactions')]"
                            *ngIf="globals.storeSettings && globals.storeSettings.type == 'partner'">{{ 'Saldo' | translate }}:
                            {{utility.numberFormat(globals.storeSettings.credits)}}</h6>
                        <button mat-stroked-button class="add-credits-btn"
                            [routerLink]="[globals.panelUrl('/credit-transactions')]"
                            *ngIf="globals.storeSettings && globals.storeSettings.type == 'partner' && globals.storeSettings.platform === 'shopify'">
                            {{ 'Add credits' | translate }}
                        </button>
                    </div>


                </div>
            </div>

            <div class="menu print-hide" *ngIf="globals.storeSettings">
                <div class="row">
                    <div class="col-auto" *ngIf="globals.currentUser">
                        <button mat-menu-item class="" [routerLink]="[globals.panelUrl('/')]">
                            <span class="material-symbols-outlined">home</span>
                            <span>{{ 'Översikt' | translate }}</span>
                        </button>
                    </div>
                    <div class="col-auto" *ngIf="globals.adminKey && !globals.currentUser">
                        <button mat-menu-item class="partner-store-admin-color"
                            [routerLink]="[globals.panelUrl('/store-settings')]">
                            <span class="material-symbols-outlined partner-store-admin-color">settings</span>
                            <span>{{ 'Inställningar' | translate }}</span>
                        </button>
                    </div>
                    <div class="col-auto" *ngIf="globals.adminKey && !globals.currentUser">
                        <button mat-menu-item class="partner-store-admin-color" [routerLink]="[globals.panelUrl('/print-files')]">
                            <span class="material-symbols-outlined partner-store-admin-color">wallpaper</span>
                            <span>{{ 'Tryckfiler' | translate }}</span>
                        </button>
                    </div>
                    <div class="col-auto">
                        <button mat-menu-item [routerLink]="[globals.panelUrl('/posters')]">
                            <span class="material-symbols-outlined">wall_art</span>
                            <span>{{ 'Produkter' | translate }}</span>
                        </button>
                    </div>
                    <div class="col-auto">
                        <button mat-menu-item [routerLink]="[globals.storeUrl('/orders')]">
                            <span class="material-symbols-outlined">paid</span>
                            <span>{{ 'Ordrar' | translate }}</span>
                        </button>
                    </div>
                    <div class="col-auto"
                        *ngIf="globals.adminKey || (globals.currentUser && globals.currentUser.role == 'ACE') || globals.storeSettings.enabledFeatures.tools">
                        <button mat-menu-item
                            [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.tools}"
                            [matMenuTriggerFor]="toolsMenu">
                            <span class="material-symbols-outlined"
                                [ngClass]="{'partner-store-admin-color': !globals.storeSettings.enabledFeatures.tools}">construction</span>
                            <span>{{ 'Verktyg' | translate }}</span>
                        </button>
                    </div>



                    <div class="col-auto" *ngIf="globals.currentUser && globals.storeSettings.type == 'partner'">
                        <button mat-menu-item [matMenuTriggerFor]="helpMenu">
                            <span class="material-symbols-outlined">support</span>
                            <span>{{ 'Hjälp' | translate }}</span>
                        </button>
                    </div>



                    <div class="col-auto" *ngIf="globals.stores && globals.stores.length > 1">
                        <button mat-menu-item [matMenuTriggerFor]="storesMenu">
                            <span class="material-symbols-outlined">storefront</span>
                            <span>{{ 'Butiker' | translate }}</span>
                        </button>
                    </div>

                    <div class="col-auto" *ngIf="globals.currentUser && globals.currentUser.role == 'ACE'">
                        <button mat-menu-item [matMenuTriggerFor]="adminMenu" class="admin-color">
                            <span class="material-symbols-outlined admin-color">neurology</span>
                            <span>{{ 'Superadmin' | translate }}</span>
                        </button>
                    </div>
                </div>
                <br />



                <mat-menu #helpMenu>
                    <button mat-menu-item [routerLink]="[globals.storeUrl('/help')]">
                        <span class="material-symbols-outlined partner-color">psychology_alt</span>
                        <span class="partner-color">FAQ</span>
                    </button>

                    <button mat-menu-item [routerLink]="[globals.storeUrl('/price-list')]">
                        <span class="material-symbols-outlined partner-color">price_check</span>
                        <span class="partner-color">{{ 'Price list' | translate }}</span>
                    </button>

                    <button mat-menu-item [routerLink]="[globals.storeUrl('/product-overview')]">
                        <span class="material-symbols-outlined partner-color">apparel</span>
                        <span class="partner-color">{{ 'Tillgängliga produkter' | translate }}</span>
                    </button>
                </mat-menu>


                <mat-menu #toolsMenu>
                    <button mat-menu-item
                        *ngIf="(globals.adminKey || (globals.currentUser && globals.currentUser.role == 'ACE')) || globals.storeSettings.enabledFeatures.createOrder"
                        [routerLink]="[globals.panelUrl('/create-order')]">
                        <span class="material-symbols-outlined"
                            [ngClass]="{'admin-color': !globals.storeSettings.enabledFeatures.createOrder, 'partner-color': globals.storeSettings.enabledFeatures.createOrder}">add</span>
                        <span class=""
                            [ngClass]="{'admin-color': !globals.storeSettings.enabledFeatures.createOrder, 'partner-color': globals.storeSettings.enabledFeatures.createOrder}">{{ 'Skapa order' | translate }}</span>
                    </button>

                    <button mat-menu-item
                        *ngIf="(globals.adminKey || (globals.currentUser && globals.currentUser.role == 'ACE')) || globals.storeSettings.enabledFeatures.generateBarcode"
                        [routerLink]="[globals.panelUrl('/barcode-generator')]">
                        <span class="material-symbols-outlined"
                            [ngClass]="{'admin-color': !globals.storeSettings.enabledFeatures.generateBarcode, 'partner-color': globals.storeSettings.enabledFeatures.generateBarcode}">barcode</span>
                        <span class=""
                            [ngClass]="{'admin-color': !globals.storeSettings.enabledFeatures.generateBarcode, 'partner-color': globals.storeSettings.enabledFeatures.generateBarcode}">{{ 'Skapa barcode' | translate }}</span>
                    </button>

                    <button mat-menu-item
                        *ngIf="(globals.adminKey || (globals.currentUser && globals.currentUser.role == 'ACE')) || globals.storeSettings.enabledFeatures.testBarcode"
                        [routerLink]="[globals.panelUrl('/barcode-tester')]">
                        <span class="material-symbols-outlined"
                            [ngClass]="{'admin-color': !globals.storeSettings.enabledFeatures.testBarcode, 'partner-color': globals.storeSettings.enabledFeatures.testBarcode}">check</span>
                        <span class=""
                            [ngClass]="{'admin-color': !globals.storeSettings.enabledFeatures.testBarcode, 'partner-color': globals.storeSettings.enabledFeatures.testBarcode}">{{ 'Testa barcode' | translate }}</span>
                    </button>

                    <button mat-menu-item [routerLink]="[globals.panelUrl('/credit-transactions')]">
                        <span class="partner-color material-symbols-outlined">wallet</span>
                        <span class="partner-color">{{ 'Debiteringar' | translate }}</span>
                    </button>

                    <!--
          <button mat-menu-item *ngIf="globals.adminKey || globals.currentUser && " [routerLink]="[globals.panelUrl('/barcode-generator')]">
            <span class="admin-color material-symbols-outlined">barcode</span>
            <span class="admin-color">{{ 'Skapa barcode' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/barcode-tester')]">
            <span class="admin-color material-symbols-outlined">check</span>
            <span class="admin-color">{{ 'Testa barcode' | translate }}</span>
          </button>

        -->
                    <!--
          <button mat-menu-item *ngIf="globals.adminKey" [routerLink]="[globals.panelUrl('/image-generator')]">
            <span class="admin-color material-symbols-outlined">neurology</span>
            <span class="admin-color">{{ 'Generera bilder' | translate }}</span>
          </button>
        -->
                </mat-menu>

                <mat-menu #storesMenu *ngIf="globals.stores && globals.stores.length > 1" class="partner-themed">
                    <a mat-menu-item *ngFor="let store of globals.stores" [href]="globals.storeUrl('/', store._id, true)">
                        <button class="menu-button mat-mdc-menu-item">
                            <span class="partner-color">{{store.name}}</span>
                        </button>
                    </a>
                </mat-menu>


                <mat-menu #adminMenu *ngIf="globals.currentUser && globals.currentUser.role == 'ACE'">
                    <button mat-menu-item class="admin-color" [routerLink]="[globals.panelUrl('/store-settings')]">
                        <span class="material-symbols-outlined admin-color">settings</span>
                        <span>{{ 'Inställningar' | translate }}</span>
                    </button>
                    <button mat-menu-item class="admin-color" [routerLink]="[globals.panelUrl('/print-files')]">
                        <span class="material-symbols-outlined admin-color">wallpaper</span>
                        <span>{{ 'Tryckfiler' | translate }}</span>
                    </button>
                    <button mat-menu-item class="admin-color" [routerLink]="[globals.panelUrl('/generate-artworks')]">
                        <span class="material-symbols-outlined admin-color">image</span>
                        <span>{{ 'Generera bilder' | translate }}</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="content" [ngClass]="{'container-background':globals.currentUser}">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<ng-template #onboardingPendingDialog>
    <h2 mat-dialog-title>Welcome!</h2>
    <mat-dialog-content>
        <p>You can now start to receive orders from your store.</p>
        <p>Your orders will be queued. For live production, you need to top up your credits.</p>
        <p>You can test the complete order and Shopify fulfillment flow immediately without contacting support or sending anything to physical production.</p>

        <div class="review-mode-activation" [class.active]="globals.storeSettings.reviewMode">
            <div>
                <strong>{{ globals.storeSettings.reviewMode ? 'Review mode is active' : 'Test the complete workflow' }}</strong>
                <p *ngIf="!globals.storeSettings.reviewMode">Activate review mode to receive 1,000 test credits and safely simulate payment, production, fulfillment, and Shopify synchronization.</p>
                <p *ngIf="globals.storeSettings.reviewMode">{{ globals.storeSettings.reviewModeCredits | number:'1.0-2' }} test credits are available. Review-mode orders can only be advanced with the simulation controls on the Orders page.</p>
            </div>
            <button *ngIf="!globals.storeSettings.reviewMode" mat-raised-button color="primary"
                [disabled]="activatingReviewMode" (click)="activateReviewMode()">
                {{ activatingReviewMode ? 'Activating...' : 'Activate review mode' }}
            </button>
        </div>
        <p class="review-mode-error" *ngIf="reviewModeActivationError">{{ reviewModeActivationError }}</p>

        <section class="onboarding-next-steps">
            <h3>Next steps</h3>
            <ol>
                <li>
                    <span class="step-number">1</span>
                    <div>
                        <strong>Review the ACE-compatible SKUs</strong>
                        <p>Take a look at the available examples before configuring your products.</p>
                        <a [href]="globals.storeUrl('/help', globals.storeSettings._id, true) + '#sku-examples'" target="_blank" rel="noopener">
                            View SKU examples
                        </a>
                    </div>
                </li>
                <li>
                    <span class="step-number">2</span>
                    <div>
                        <strong>Update an existing product</strong>
                        <p>Set its SKU to an ACE-compatible value. For example, use <code>POSTER_100x70_MANUAL</code> for a 100x70cm poster where you upload the print file manually after each order.</p>
                    </div>
                </li>
                <li>
                    <span class="step-number">3</span>
                    <div>
                        <strong>Place a test order</strong>
                        <p>Order the product you configured, then confirm that it appears in your dashboard.</p>
                        <a [href]="globals.storeUrl('/orders', globals.storeSettings._id, true)" target="_blank" rel="noopener">
                            Check your orders
                        </a>
                    </div>
                </li>
                <li>
                    <span class="step-number">4</span>
                    <div>
                        <strong>Contact ACE Print Partner</strong>
                        <p>When you are ready for live production, email <a href="mailto:info@aceprintpartner.com">info@aceprintpartner.com</a> or top up your credits.</p>
                    </div>
                </li>
            </ol>
        </section>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" mat-dialog-close>I got it</button>
    </mat-dialog-actions>
</ng-template>